export enum ParticipantsPagerDataHooks {
  ROOT = 'participants-pager',
  PREV_BUTTON = 'participants-pager-prev',
  NEXT_BUTTON = 'participants-pager-next',
  LABEL = 'participants-pager-label',
  DOT_NAVIGATION = 'participants-pager-dots',
}
